import { Component, Watch, Vue } from 'vue-property-decorator';
import appStore from '@/store/app';
import bannersStore from '@/store/banners';
import { Banner } from '@/models';
import CardComponent from '@/components/CardComponent';
import ListToolbar from '@/components/ListToolbar';
import { Guid } from '@/types';
import { debounce } from '@/core/debounce';
import { addDays } from '@/filters';
// import tracer from '@/core/tracer';

@Component({
   components: { CardComponent, ListToolbar },
})
export default class Banners extends Vue {

   private pageNumber = 1;
   private selected: Banner | null = null;
   private fromDate: Date = addDays(new Date(), -30);
   private toDate: Date = addDays(new Date(), 30);

   private debouncedSearchBannersAsync = async (): Promise<void> => undefined;

   get pageSize(): number {
      return appStore.pageSize;
   }

   get total(): number {
      return bannersStore.total;
   }

   get banners(): Banner[] | undefined {
      return bannersStore.banners;
   }

   get loading(): boolean {
      return appStore.isLoading;
   }

   get canRemove(): boolean {
      return !!this.selected;
   }

   get canEdit(): boolean {
      return !!this.selected;
   }

   private async created() {
      this.debouncedSearchBannersAsync = debounce(this.searchBannersAsync, 600);
      if (!this.banners || this.total === 0) {
         await this.searchBannersAsync();
      }
   }

   private async mounted() {
      await appStore.activateMenuById({ rootId: 500, subMenuId: 501 });
   }

   @Watch('fromDate', { immediate: false, deep: false })
   private async onFromDateChanged(value: Date, previousValue?: Date) {
      // tracer('onKeywordChanged', [value, previousValue]);
      if (previousValue === undefined) return;

      this.pageNumber = 1;
      await this.debouncedSearchBannersAsync();
   }

   @Watch('toDate', { immediate: false, deep: false })
   private async onToDateChanged(value: Date, previousValue?: Date) {
      // tracer('onKeywordChanged', [value, previousValue]);
      if (previousValue === undefined) return;

      this.pageNumber = 1;
      await this.debouncedSearchBannersAsync();
   }

   private async addBanner() {
      await this.$router.push({ name: 'banner', params: { id: Guid.Empty } });
   }

   private async deleteBanner() {
      if (!this.selected) { return; }

      const selectedId: string = this.selected.id;

      this.$buefy.dialog.confirm({
         title: 'Eliminazione utente',
         message: 'Sei sicuro/a di voler <b>rimuovere</b> il banner selezionato?',
         confirmText: 'Conferma',
         cancelText: 'Annulla',
         type: 'is-warning',
         hasIcon: true,
         onConfirm: async () => {
            await bannersStore.deleteBannerAsync({ id: selectedId });
         },
      });
   }

   private select(row: Banner, oldRow: Banner | null): void {
      this.selected = row;
   }

   private async editBanner(banner: Banner) {
      const selectedId: string = banner ? banner.id : (this.selected as Banner).id;
      await this.$router.push({ name: 'banner', params: { id: selectedId } });
   }

   private async refresh() {
      this.pageNumber = 1;
      await this.searchBannersAsync();
   }

   private async onPageChange(page: number) {
      this.pageNumber = page;
      await this.searchBannersAsync();
   }

   private async searchBannersAsync() {
      await bannersStore.fetchBannersAsync({ fromDate: this.fromDate, toDate: this.toDate, pageNumber: this.pageNumber, pageSize: this.pageSize });
   }
}
